import { Icon } from "@monta/design-system";
import { Profile as ProfileIcon } from "@monta/icons";
import { fixString } from "@monta/router-js";
import type { TUtils } from "@monta/utils";
import { UsersTypeEnum } from "@monta/utils";
import { getUserTypeName } from "../../../../../utils/functions/userTypeIds";
import styles from "./profile.module.scss";

export interface ProfileProps {
  auth: TUtils["auth"];
}

const Profile = (props: ProfileProps) => {
  const { auth } = props;
  const loginInfo = auth.useAuth();

  return (
    <div className={styles["profile"]}>
      {loginInfo?.imageId ? (
        <div className={styles["profile__image"]}>
          <img
            width={32}
            height={32}
            src={fixString(`/render?id=${loginInfo.imageId}`, "GWT_URL")}
            alt={"profile-image"}
          />
        </div>
      ) : (
        <div className={styles["profile__icon"]}>
          <ProfileIcon />
        </div>
      )}

      <div className={styles["profile__name"]}>
        <div>
          {loginInfo?.name}
          <label className={styles["profile__name__type"]}>
            {getUserTypeName(loginInfo?.subTypeId)}
          </label>
        </div>
        <Icon
          icon={"mi-Arrow-Down"}
          className={styles["profile__name__icon"]}
        />
      </div>

      <div className={styles["profile__sub"]}>
        <div className={styles["profile__sub__item"]}>
          <a href={fixString(`/#!userProfile;a21=${loginInfo?.id}`, "GWT_URL")}>
            <span>پروفایل</span>
          </a>
        </div>
        {loginInfo?.subTypeId != UsersTypeEnum.EXAM_MARKET_PROVIDER &&
          !loginInfo?.isDependent && (
            <div className={styles["profile__sub__item"]}>
              <a href={fixString("/profile/account-list", "APPLICATION_URL")}>
                <span>
                  {Number(loginInfo?.accountsCount) > 1
                    ? "تغییر نقش"
                    : "افزودن حساب کاربری"}
                </span>
              </a>
            </div>
          )}
        <div className={styles["profile__sub__item"]}>
          <a href={fixString("/auth/forget/change", "APPLICATION_URL")}>
            <span>تغییر رمز</span>
          </a>
        </div>
        <div
          className={styles["profile__sub__item"]}
          onClick={() => auth.logout(true)}
        >
          خروج
        </div>
      </div>
    </div>
  );
};

export default Profile;
